export default __webpack_public_path__ + "static/media/courseLanding-PPII.3c66c6fc.png";